import React from 'react';
import PropTypes from 'prop-types';

const DownloadOutline = ({ fill = 'var(--PRIMARY)' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.8825 7.305H11.4825V2.7225C11.4825 2.62305 11.443 2.52766 11.3727 2.45734C11.3023 2.38701 11.207 2.3475 11.1075 2.3475H6.89251C6.79305 2.3475 6.69767 2.38701 6.62734 2.45734C6.55702 2.52766 6.51751 2.62305 6.51751 2.7225V7.305H4.11751C4.04256 7.30455 3.96919 7.32657 3.90688 7.36821C3.84456 7.40986 3.79616 7.46922 3.7679 7.53864C3.73965 7.60806 3.73285 7.68435 3.74837 7.75768C3.7639 7.831 3.80104 7.89799 3.85501 7.95L8.73751 12.8325C8.8076 12.9012 8.90185 12.9397 9.00001 12.9397C9.09816 12.9397 9.19241 12.9012 9.26251 12.8325L14.145 7.95C14.199 7.89799 14.2361 7.831 14.2516 7.75768C14.2672 7.68435 14.2604 7.60806 14.2321 7.53864C14.2039 7.46922 14.1554 7.40986 14.0931 7.36821C14.0308 7.32657 13.9575 7.30455 13.8825 7.305ZM8.17501 9V3.9975H9.82501V9H10.7925L9.00001 10.755L7.20751 9H8.17501ZM4.03501 14.0025H13.965C14.0733 14.0025 14.1806 14.0238 14.2807 14.0653C14.3808 14.1068 14.4718 14.1675 14.5484 14.2441C14.625 14.3207 14.6857 14.4117 14.7272 14.5118C14.7687 14.6119 14.79 14.7192 14.79 14.8275C14.79 14.9358 14.7687 15.0431 14.7272 15.1432C14.6857 15.2433 14.625 15.3343 14.5484 15.4109C14.4718 15.4875 14.3808 15.5482 14.2807 15.5897C14.1806 15.6312 14.0733 15.6525 13.965 15.6525H4.03501C3.8162 15.6525 3.60636 15.5656 3.45164 15.4109C3.29693 15.2561 3.21001 15.0463 3.21001 14.8275C3.21001 14.6087 3.29693 14.3989 3.45164 14.2441C3.60636 14.0894 3.8162 14.0025 4.03501 14.0025Z"
      fill={fill}
    />
  </svg>
);

DownloadOutline.propTypes = {
  fill: PropTypes.string,
};

export default DownloadOutline;
